import { ECategory } from '@common/enums/category.enum';

export const getCategoryTitle = (category: ECategory): string => {
    switch (category) {
        case ECategory['fruit-and-veg-box']:
            return 'Fruit & Veg';
        case ECategory['veg-box']:
            return 'Veg Only';
        case ECategory['fruit-box']:
            return 'Fruit Only';
    }
    return '';
};
